import { ShallowRule } from "@shared/types";

import { authPost } from "../auth";

import { RulePostParams } from "./types";

export const postRule = (data: RulePostParams) => {
  return authPost<RulePostParams, ShallowRule>(`/api/registry/rules`, data);
};
